"use client";
import { Input, Skeleton } from "antd";
import btn_back from "@/app/assets/orders/btn_back@2x.png";
import Image from "next/image";
import { useRouter } from "next/navigation";
import { useSearchParams } from "next/navigation";
import { SearchOutlined } from "@ant-design/icons";
import IndexIcon from "@/app/assets/search/indexIcon.png";
import { searchMarkets, searchRecommend } from "@/service/search";
import { useEffect, useState } from "react";
import useSWR from "swr";
import { SearchItemResult } from "./components/SearchItemResult";

type SearchPageProps = {};

export const SearchPage: React.FC<SearchPageProps> = ({ ...props }) => {
  const router = useRouter();
  const searchParams = useSearchParams();
  const keywords = searchParams.get("keywords");
  const goBack = () => {
    router.back()
  }

  const [searchText, setSearchText] = useState(keywords || "");
  const [searchRecommendResult, setSearchRecommendResult] = useState<any[]>([]);

  useEffect(() => {
    searchRecommendFn();
  }, []);

  const searchRecommendFn = async () => {
    const { data, message, status } = await searchRecommend();
    if (status === "SUCCESS") {
      setSearchRecommendResult(data || []);
    }
  }

  const { data: searchResult = [], isValidating, mutate } = useSWR(["searchMarkets"], async () => {
    if (searchText.trim() === "" || !searchText) {
      return []
    } else {
      const { data } = await searchMarkets({
        q: searchText
      })
      return data
    }
  }, {
    revalidateOnFocus: false,
    revalidateIfStale: false
  })

  const searchOnclick = () => {
    mutate();
  };


  return (
    <div className="w-full h-full relative overflow-hidden">
      <div className="pr-20 pl-15 flex items-center mb-10 pt-14">
        <div className="" onClick={goBack}>
          <Image src={btn_back} alt="btn_back" width={28} height={28} />
        </div>
        <div className="flex-1 flex justify-center items-center px-15">
          <Input
            style={{
              border: "none",
              height: '3.5rem',
              backgroundColor: '#ffffff20',
              borderRadius: '10rem',
              paddingLeft: '1rem',
            }}
            prefix={<SearchOutlined color="#ffffff50" />}
            placeholder="Search"
            allowClear={true}
            value={searchText}
            onChange={(event) => setSearchText(event.target.value)}
            onPressEnter={searchOnclick}
          />
        </div>
        <div className="text-13 text-bravve-200 font-bold" onClick={searchOnclick}>
          Search
        </div>
      </div>
      <div className="px-20 h-[calc(100vh-6.5rem)] overflow-y-auto pb-20">
        {/* Result */}
        <Skeleton active loading={isValidating}>
          <SearchItemResult itemData={searchResult} isShowNoData={true} />
        </Skeleton>
        {/* Trending */}
        <div>
          <div className="flex items-center gap-5 mt-10">
            <Image src={IndexIcon} alt="IndexIcon" width={20} height={20} />
            <div className="text-15 font-bold text-[#FFED41] leading-20">Trending</div>
          </div>
          <SearchItemResult itemData={searchRecommendResult} />
        </div>
      </div>
    </div>
  );
}
